import React from "react";
import { useLocation } from "react-router-dom";
import ViewPolicy from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/ViewPolicy";
import LatestPolicyRedirect from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/LatestPolicyRedirect";
import { readOptionalPolicyId } from "accountOwner/pages/OfficePolicyManagement/hooks/useLatestPolicyRedirect";

/**
 * Owner policy view route.
 * A direct link with `policyId` resolves the latest assignment and opens details.
 * In-app policy view (`policyView=1`) and links without a policy id keep the existing view.
 */
export default function OwnerPolicyViewEntry() {
  const location = useLocation();
  const params = new URLSearchParams(location.search || "");
  const stayOnPolicyView = params.get("policyView") === "1";
  const policyId = readOptionalPolicyId(location.search);

  if (stayOnPolicyView || !policyId) {
    return <ViewPolicy />;
  }

  return <LatestPolicyRedirect />;
}
